export enum TabsType {
  Overview = 'overview',
  Financials = 'financials',
  Chart = 'chart',
  KnowledgeGraph = 'knowledgeGraph',
  NewsInsights = 'newsInsights',
  Documents = 'documents',
  Earnings = 'earnings',
}
